import React, { useEffect, useRef } from 'react';
import '../styles/BlinkingStars.css';

const StarsBackground = () => {
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;
    
    // Clear any existing stars
    container.innerHTML = '';
    
    // Create stars
    const createStars = (count) => {
      for (let i = 0; i < count; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        
        // Random size between 1px and 3px
        const size = Math.random() * 2 + 1;
        star.style.width = `${size}px`;
        star.style.height = `${size}px`;
        
        // Random position
        const left = Math.random() * containerWidth;
        const top = Math.random() * containerHeight;
        star.style.left = `${left}px`;
        star.style.top = `${top}px`;
        
        // Random animation duration between 3s and 7s
        const duration = Math.random() * 4 + 3;
        star.style.setProperty('--duration', `${duration}s`);
        
        // Random max opacity between 0.5 and 1
        const maxOpacity = Math.random() * 0.5 + 0.5;
        star.style.setProperty('--max-opacity', maxOpacity);
        
        // Random delay to start the animation
        const delay = Math.random() * 7;
        star.style.animationDelay = `${delay}s`;
        
        container.appendChild(star);
      }
    };
    
    // Create different sizes of stars
    createStars(150); // 150 small stars
    
    // Add some larger "highlight" stars
    for (let i = 0; i < 20; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      
      // Larger size between 3px and 4px
      const size = Math.random() * 1 + 3;
      star.style.width = `${size}px`;
      star.style.height = `${size}px`;
      
      // Random position
      const left = Math.random() * containerWidth;
      const top = Math.random() * containerHeight;
      star.style.left = `${left}px`;
      star.style.top = `${top}px`;
      
      // Random animation duration
      const duration = Math.random() * 5 + 4;
      star.style.setProperty('--duration', `${duration}s`);
      
      // Higher opacity for the larger stars
      const maxOpacity = Math.random() * 0.3 + 0.7;
      star.style.setProperty('--max-opacity', maxOpacity);
      
      // Random delay to start the animation
      const delay = Math.random() * 7;
      star.style.animationDelay = `${delay}s`;
      
      // Add some color to a few stars
      if (Math.random() > 0.7) {
        const colors = ['#FF4FBF', '#9D4EDD', '#5B5FFF', '#00DDFF'];
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        star.style.backgroundColor = randomColor;
        star.style.boxShadow = `0 0 4px ${randomColor}`;
      } else {
        star.style.backgroundColor = 'white';
        star.style.boxShadow = '0 0 2px rgba(255, 255, 255, 0.8)';
      }
      
      container.appendChild(star);
    }
    
    // Handle window resize
    const handleResize = () => {
      // Clear and recreate stars when the window is resized
      container.innerHTML = '';
      createStars(150);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <>
      <div className="stars-container" ref={containerRef}></div>
      <div className="ambient-glow"></div>
    </>
  );
};

export default StarsBackground;